import BaseLevelScene from './BaseLevelScene';

export default class PowerPlantScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  name: string;
  tileMapName: string;
  tileMapPath: string;
  readyToRefresh: boolean = false;
  constructor(name: string, tilemapName:string, tileMapPath: string) {
    super(name);
    this.name = name;
    this.tileMapName = tilemapName;
    this.tileMapPath = tileMapPath;
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG files
    this.load.image('sewer2', 'assets/sourceImages/tfsewer_tileset_master.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      this.tileMapName,
      this.tileMapPath
    );

}

  create() {
    // create the Tilemap
    console.log(this.tileMapName);
    this.map = this.make.tilemap({ key: this.tileMapName });



    // add all tileset image we are using (note name must match tileset in map)
    const tilesetNames = this.map.tilesets.map(ts => ts.name);
    const tilesets = tilesetNames.map(name => this.map.addTilesetImage(name, name));


    // // create the layers we want in the right order
    const base = this.map.createLayer('Base', tilesets);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(base);

    const textures = this.map.createLayer('Textures', tilesets);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    const furniture = this.map.createLayer('Furniture', tilesets);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    const decorations = this.map.createLayer('Decorations', tilesets);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(decorations);

    // create base level
    this.createBaseLevel(0.5, 2.5);
  }
}
